import { StyleSheet } from "react-native";
import { useTranslation } from "react-i18next";
import type { Exercise, Program } from "@heraion/shared";

import { Button } from "../primitives/Button";
import type { PlanGapsLauncher } from "../Progress/planGaps";
import type { UiTheme } from "../theme";
import { useProgramPlanFit } from "./useProgramPlanFit";

// #492 F5, #540: the card's «Plan today's gaps» button, the SAME on every
// card. Greyed (and spoken as disabled) when the program leaves no muscle
// under MEV: no new text, so the card keeps its height. It hands the fit to
// the host for today's draft, where the bodyweight toggle lives. Nothing is
// written.
export function ProgramPlanGaps({
  program,
  catalog,
  onPlanGaps,
  theme,
}: {
  program: Program;
  catalog: ReadonlyArray<Exercise> | null;
  onPlanGaps: PlanGapsLauncher;
  theme: UiTheme;
}) {
  const { t } = useTranslation();
  const fit = useProgramPlanFit(program, catalog);
  const none = !fit || fit.belowMev.length === 0;
  return (
    <Button
      theme={theme}
      variant="secondary"
      icon="target"
      label={t("progress.planGaps.button", { defaultValue: "Plan today's gaps" })}
      accessibilityHint={
        none
          ? t("progress.planGaps.noGaps", {
              defaultValue: "Nothing below the minimum on the cycle.",
            })
          : t("progress.planGaps.buttonHint", {
              defaultValue: "Opens today's draft in the logger. The program does not change.",
            })
      }
      onPress={() => {
        if (fit) onPlanGaps({ fit });
      }}
      disabled={none}
      style={styles.button}
    />
  );
}

const styles = StyleSheet.create({
  button: { alignSelf: "flex-start" },
});
